import { Alert, Button, Paper, PasswordInput, Stack, Text, Title } from '@mantine/core';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { api } from '../api';
import { useAuthStore } from '../stores/auth-store';

export function ProfilePage() {
  const user = useAuthStore((state) => state.user)!;
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState<{ color: 'red' | 'green'; text: string } | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (newPassword !== confirm) {
      setMessage({ color: 'red', text: 'The new passwords do not match.' });
      return;
    }
    setLoading(true);
    const response = await api.api.api.v1.auth['change-password'].post({
      currentPassword,
      newPassword,
    });
    setLoading(false);
    if (response.error) {
      setMessage({ color: 'red', text: 'Your current password is incorrect.' });
      return;
    }
    setMessage({ color: 'green', text: 'Password changed. Please sign in again.' });
    setTimeout(() => {
      logout();
      void navigate('/login');
    }, 1000);
  }

  return (
    <Stack gap='lg' maw={650} mx='auto'>
      <div>
        <Title order={1}>My account</Title>
        <Text c='dimmed' mt={5}>
          {user.email}
        </Text>
      </div>
      <Paper withBorder radius='lg' p='xl'>
        <form onSubmit={submit}>
          <Stack>
            <div>
              <Title order={3}>Change password</Title>
              <Text size='sm' c='dimmed'>
                Changing your password revokes every active session.
              </Text>
            </div>
            {message && <Alert color={message.color}>{message.text}</Alert>}
            <PasswordInput
              label='Current password'
              required
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.currentTarget.value)}
            />
            <PasswordInput
              label='New password'
              required
              minLength={10}
              value={newPassword}
              onChange={(event) => setNewPassword(event.currentTarget.value)}
            />
            <PasswordInput
              label='Confirm new password'
              required
              minLength={10}
              value={confirm}
              onChange={(event) => setConfirm(event.currentTarget.value)}
            />
            <div>
              <Button type='submit' loading={loading}>
                Update password
              </Button>
            </div>
          </Stack>
        </form>
      </Paper>
    </Stack>
  );
}
